export default {
  debounce: (cb, ms) => {
    let timer = null;
    return () => {
      clearTimeout(timer);
      timer = setTimeout(() => { cb(); }, ms);
    };
  },
  throttle: (cb, ms) => {
    let timer = null;
    let startTime = Date.now();
    return () => {
      const currentTime = Date.now();
      const remaining = ms - (currentTime - startTime);
      clearTimeout(timer);
      if (remaining <= 0) {
        cb();
        startTime = Date.now();
      } else {
        timer = setTimeout(() => {
          cb();
        }, remaining);
      }
    };
  },
  createNumber(val, start) {
    const strVal = `${val}`;
    const len = 7 - (strVal.length);
    return start + (Array(len).join(0)) + strVal;
  },
  hasPermission(node) {
    const authId = localStorage.getItem('auth_id');
    const nodes = JSON.parse(localStorage.getItem("nodes"))
    console.log(nodes, authId)
    if (!nodes || !authId) return false
    if (authId == 0) return true;
    return nodes.findIndex(item => item === node) > -1;
  },
};



// WEBPACK FOOTER //
// ./src/utils/index.js